/**
 * @generated SignedSource<<b5fdbab55df24f332609b1e089f7e812>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchCompassComponent_AtlassianSearchPage$data = {
  readonly __typename: "SearchResultCompassComponent";
  readonly component: {
    readonly description: string | null | undefined;
    readonly state: string | null | undefined;
  } | null | undefined;
  readonly description: string;
  readonly id: string;
  readonly lastModifiedDate: string | null | undefined;
  readonly tier: string | null | undefined;
  readonly title: string;
  readonly type: SearchResultType;
  readonly url: string;
  readonly " $fragmentType": "searchCompassComponent_AtlassianSearchPage";
};
export type searchCompassComponent_AtlassianSearchPage$key = {
  readonly " $data"?: searchCompassComponent_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchCompassComponent_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "description"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "searchCompassComponent_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "title"
    },
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "lastModifiedDate"
    },
    {
      "kind": "ScalarField",
      "name": "tier"
    },
    {
      "concreteType": "CompassComponent",
      "kind": "LinkedField",
      "name": "component",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "state"
        }
      ]
    }
  ],
  "type": "SearchResultCompassComponent"
};
})();

(node as any).hash = "c2a052c4a3d75d6d671dbff5b4efcf18";

export default node;
